import React, { useState, useEffect } from 'react';
import PortfolioNav from '../widgets/PortfolioNav';
import Hero from '../widgets/hero';
import AboutMe from '../widgets/aboutme';
import Skills from '../widgets/skills';
import Workflow from '../widgets/workflow';
import Projects from '../widgets/projects';
import Experience from '../widgets/experience';
import Contact from '../widgets/contact';
import Footer from '../widgets/footer';
import Preloader from '../widgets/preloader';

function Portfolio() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Show splash screen for 3 seconds
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        // Lock/Unlock scroll during loading
        if (isLoading) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            clearTimeout(timer);
            document.body.style.overflow = 'auto';
        };
    }, [isLoading]);

    return (
        <div className="flex flex-col min-h-screen bg-dark-bg transition-colors duration-300 relative scroll-smooth">

            {/* Top Navigation specific for portfolio */}
            <PortfolioNav />

            {/* Scrollable Container */}
            <div className="flex-1 w-full">

                {/* Portfolio Content Areas */}
                <main>
                    {isLoading && <Preloader />}
                    <Hero />
                    <AboutMe />
                    <Skills />
                    <Workflow />
                    <Projects />
                    <Experience />
                    <Contact />
                </main>

                {/* Footer */}
                <Footer />
            </div>
        </div>
    );
}

export default Portfolio;
